import React from 'react';
import { GoInfo } from "react-icons/go";
import { ErrorBox } from './common/ErrorBox';
import { AiOutlineInfoCircle } from 'react-icons/ai';
import { useFormContext } from 'react-hook-form';

const DimensionPicker = ({ name, label,title, errors, detailed_label, validation }) => {
  const { register} = useFormContext();

  return (
    <div className="">
      <div className="flex justify-between">
      <h1 className='text-2xl uppercase text-blue-600 font-semibold	 '>{title}</h1>
        <AiOutlineInfoCircle className="text-blue-600 text-xl" />
      </div>

      <p className="text-sm font-medium mt-2">{detailed_label}</p>
      <div className="flex justify-between space-x-4 mt-2">
        <div className='w-full'>
          <label htmlFor={`${name}.WIDTH`} className="block mb-2 text-sm font-medium text-gray-900 ">Breedte (cm)</label>
          <input
            id={`${name}.WIDTH`}
            type="number"
            {...register(`${name}.WIDTH`, validation?.WIDTH)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400  dark:focus:ring-blue-500 dark:focus:border-blue-500"
            
            placeholder="Breedte"
          />
                    <ErrorBox key={1} errors={errors?.WIDTH} />

        </div>
        <div className='w-full'>
          <label htmlFor={`${name}.HEIGHT`} className="block mb-2 text-sm font-medium text-gray-900 ">Hoogte (cm)</label>
          <input
            id={`${name}.HEIGHT`}
            type="number"
            {...register(`${name}.HEIGHT`, validation?.HEIGHT)}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400  dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Hoogte"
          />
                    <ErrorBox key={2} errors={errors?.HEIGHT} />

        </div>
      </div>
    </div>
  );
};

export default DimensionPicker;
